/* eslint-disable react/no-children-prop */

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Provider } from 'react-redux';
import './AppContainer.less';
import Root from './RootContainer';

/**
 * @augments {Component<{    withRoute:boolean,    store:object.isRequired,    children:any,  >}
 */
class AppContainer extends Component {
  static propTypes = {
    withRoute: PropTypes.bool,
    store: PropTypes.object.isRequired,
    children: PropTypes.any,
  };

  static defaultProps = {
    withRoute: false,
  };

  shouldComponentUpdate() {
    return false;
  }

  render() {
    const { withRoute, store } = this.props;

    return <Provider store={store}>{withRoute ? <Root /> : this.props.children}</Provider>;
  }
}

export default AppContainer;
